import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Table from 'src/components/Table';
import TableCell from 'src/components/Table/TableCell';
import BankAccountsRow from './BankAccountsRow';

const Tbody = ({
  bankAccounts,
  clientId,
  translateBankAccountType,
  onEditAccount
}) => {
  const { t } = useTranslation();

  if (!bankAccounts || bankAccounts.length === 0) {
    return (
      <TableRow>
        <TableCell colSpan={4} align="center">
          {t('COMMON.NO_RECORDS_FOUND')}
        </TableCell>
      </TableRow>
    );
  }

  return bankAccounts.map(account => (
    <BankAccountsRow
      key={account.id}
      row={account}
      clientId={clientId}
      translateBankAccountType={translateBankAccountType}
      onEdit={onEditAccount}
    />
  ));
};

Tbody.propTypes = {
  bankAccounts: PropTypes.array,
  clientId: PropTypes.string.isRequired,
  translateBankAccountType: PropTypes.func.isRequired,
  onEditAccount: PropTypes.func
};

const BankAccountsTable = ({
  bankAccounts,
  loading,
  clientId,
  translateBankAccountType,
  onEditAccount,
  ...rest
}) => {
  const { t } = useTranslation();

  const theads = useMemo(
    () => () => (
      <TableRow component="tr">
        <TableCell variant="head" key="type" align="center">
          {t('CLIENTS_VIEW.BILLING_DETAIL.BANK_ACCOUNT_TYPE')}
        </TableCell>
        <TableCell variant="head" key="bank" align="center">
          {t('CLIENTS_VIEW.BILLING_DETAIL.BANK')}
        </TableCell>
        <TableCell variant="head" key="account-number" align="center">
          {t('CLIENTS_VIEW.BILLING_DETAIL.ACCOUNT_NUMBER')}
        </TableCell>
        <TableCell variant="head" key="actions" align="center">
          {t('COMMON.ACTIONS')}
        </TableCell>
      </TableRow>
    ),
    [t]
  );

  const tbody = useMemo(
    () => () => (
      <Tbody
        bankAccounts={bankAccounts}
        clientId={clientId}
        translateBankAccountType={translateBankAccountType}
        onEditAccount={onEditAccount}
      />
    ),
    [bankAccounts, clientId, translateBankAccountType, onEditAccount]
  );

  return (
    <Table
      style={{ tableLayout: 'fixed', width: '100%' }}
      {...rest}
      tbody={tbody}
      theads={theads}
      loading={loading}
      customMaxHeight="auto"
    />
  );
};

BankAccountsTable.propTypes = {
  bankAccounts: PropTypes.array,
  loading: PropTypes.bool,
  clientId: PropTypes.string.isRequired,
  translateBankAccountType: PropTypes.func.isRequired,
  onEditAccount: PropTypes.func
};

export default BankAccountsTable;
